import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import ActionHeader from "../../../components/ActionHeader";
import usePageState from "../../../hooks/usePageState";
import { useMemo, useState } from "react";
import { TopSaleCupResponse } from "../../../../infrastructure/model/OrderModel";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { Button, Col } from "antd";
import Row from "../../../components/Row";
import { useDateRangeSelector } from "../../../hooks/useDateRangeSelector";
import BaseTable from "../../../components/BaseTable";
import { getTopHotSaleCupUseCase } from "../../../../applications/useCase/ApiUseCase/OrderApiUseCase";
import { DATE_RANGE_OPTION_ENUM } from "../../../../applications/constants/AppConst";

function TopSaleCup() {
  const { isLoading, setLoading, showError } = usePageState();
  const [dataReport, setDataReport] = useState<TopSaleCupResponse[]>([]);

  const [total, setTotal] = useState<number>(0);

  const { startDate, endDate, DateRangeSelectorComponent, validateDateRange } =
    useDateRangeSelector({
      initSelectOptionDate: DATE_RANGE_OPTION_ENUM.TO_DAY,
    });

  async function getTopHotSaleCup() {
    if (!validateDateRange()) return;
    setDataReport([]);

    const res = await getTopHotSaleCupUseCase({
      startDate,
      endDate,
      showError,
      setLoading,
    });
    setDataReport(res);
  }

  useAsyncEffect(async () => {
    await getTopHotSaleCup();
  }, []);

  const countCups = useMemo(() => {
    return dataReport.reduce((sum, record) => sum + record.cup, 0);
  }, [dataReport]);

  return (
    <div className="h-100 flex flex-column">
      <ActionHeader
        rowCount={total}
        actions={[
          {
            icon: <ReloadOutlined />,
            isNormal: true,
            userClick: getTopHotSaleCup,
            type: "primary",
          },
        ]}
      />
      <Row
        style={{
          background: "white",
          display: "flex",
        }}
      >
        <Col span={9}>
          <Row
            className="gap-2 p-2"
            style={{
              background: "white",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <DateRangeSelectorComponent />
            <Col>
              <Button
                icon={<SearchOutlined />}
                type="primary"
                onClick={getTopHotSaleCup}
                className="w-100"
              >
                Áp dụng
              </Button>
            </Col>
          </Row>
        </Col>

        <Col span={4} className="align-items-center h-100" style={{ marginTop: "30px" }}>
          Tổng số: ({countCups}) Cốc
        </Col>
      </Row>
      <div style={{ height: `calc(100% - 60px)`, display: "flex", flexDirection: "column" }}>
        <div className="h-100 w-100">
          <BaseTable
            dataSource={dataReport}
            loading={isLoading}
            columns={[
              {
                title: "Name",
                dataIndex: "name",
                key: "name",
                width: 300,
              },
              {
                title: "Số lượng",
                dataIndex: "cup",
                key: "cuop",
                width: 300,
              },
            ]}
            rowKey={"name"}
            pagination={{
              pageSize: 50,
            }}
          />
        </div>
      </div>
    </div>
  );
}
export default TopSaleCup;
